// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6d9d2088","952":"51386335"}[chunkId] + ".chunk.js";
};